import { useQuery } from "@apollo/client";
import React from "react";
import { Radar } from "react-chartjs-2";
import { NonceProvider } from "react-select";
import { GET_DIGNOSE_COMPARISON_DATA } from "../../../../queries";

const EvaluationRadar = ({
  diagnoseData,
  orgIdArray,
  orgPk,
  avePk,
  target,
}) => {
  const { loading, error, data } = useQuery(GET_DIGNOSE_COMPARISON_DATA, {
    variables: { orgPk: orgPk, scaleAverageId: avePk, orgPks: orgIdArray },
  });

  //自団体データ
  const datasets = JSON.parse(diagnoseData.diagnoseResults.valueList);
  const labelData = diagnoseData.diagnoseResults.quetionCategory;

  const tmp = Object.values(datasets);
  let orgValue = [];
  orgValue = tmp[0][orgIdArray[0]];

  //業界平均データ
  const industryDatasets = JSON.parse(data.comparisonData.industryDiagnoseData);
  const industryValuesets = Object.values(industryDatasets);

  let industryValue = [];
  industryValue = industryValuesets[0][2];

  //組織規模別データ
  const aveDataSets = JSON.parse(
    data.revenueCategoryData.specificRevenueCategoryDiagnoseAverageData
  );

  let aveValuesets = Object.values(aveDataSets);
  let aveValue = [];
  aveValue = aveValuesets[0][2];

  const data1 = {
    labels: labelData,
    datasets: [
      {
        label: "自団体データ",
        backgroundColor: "rgba(179,181,198,0.2)",
        borderColor: "rgba(179,181,198,1)",
        pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(179,181,198,1)",
        data: orgValue,
      },
    ],
  };

  const data2 = {
    labels: labelData,
    datasets: [
      {
        label: "自団体データ",
        backgroundColor: "rgba(179,181,198,0.2)",
        borderColor: "rgba(179,181,198,1)",
        pointBackgroundColor: "rgba(179,181,198,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(179,181,198,1)",
        data: orgValue,
      },

      {
        label: target,
        backgroundColor: "rgba(255,99,132,0.2)",
        borderColor: "rgba(255,99,132,1)",
        pointBackgroundColor: "rgba(255,99,132,1)",
        pointBorderColor: "#fff",
        pointHoverBackgroundColor: "#fff",
        pointHoverBorderColor: "rgba(255,99,132,1)",
        data: target === "業界平均" ? industryValue : aveValue,
      },
    ],
  };

  const options = {
    scale: {
      max: 5,
      min: 0,
      ticks: {
        beginAtZero: true,
        stepSize: 1,
        max: 5,
        min: 0,
      },
    },
    // maintainAspectRatio: false,
    // responsive: false,
  };

  return (
    <div>
      {target === "業界平均" || target === "組織規模" ? (
        <>
          {" "}
          {aveValue.length === 0 && <p>※比較データがありません</p>}
          <Radar data={data2} options={options} />
        </>
      ) : (
        <>
          <Radar data={data1} options={options} />
        </>
      )}
    </div>
  );
};

export default EvaluationRadar;
